import { ParticipantDetailApi } from "@asd/customer-portal-api";
import { AxiosResponse } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class ParticipantDetailsService {
  static instance: ParticipantDetailsService;
  private participantDetailsApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (ParticipantDetailsService.instance) {
      return ParticipantDetailsService.instance;
    }

    this.participantDetailsApi = new ParticipantDetailApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("participantDetailsService", this.participantDetailsApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for ParticipantDetailsService");
    }
    this.axiosConfiguration = config;

    ParticipantDetailsService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  public async getParticipantDetails(options: object = {}) {
    if (!this.participantDetailsApi) {
      throw new Error("participantDetailsApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.participantDetailsApi.getParticipants(options);
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new ParticipantDetailsService();
